// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@phosphor/coreutils';
/**
 * A runtime interface token for a widget registry.
 */
export var IJupyterWidgetRegistry = new Token('jupyter.extensions.jupyterWidgetRegistry');
